import { useContext } from 'react'

import { CheckoutContext } from '~/contexts'

const useCheckoutState = () => {
  return useContext(CheckoutContext).checkoutState
}

export default useCheckoutState
